import { Alert } from '@nimbus-ds/components';
import { ProductsTemplateCsvType } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface IncompatibleFiltersAlertProps {
  show: boolean;
  template: ProductsTemplateCsvType;
}

function IncompatibleFiltersAlert({
  show,
  template,
}: Readonly<IncompatibleFiltersAlertProps>): JSX.Element | null {
  const t = useTranslationCatalog(
    'products.importExportPage.export.templateIncompatibilityAlert',
  );
  if (!show) return null;
  return <Alert appearance="warning">{t(template)}</Alert>;
}

export default IncompatibleFiltersAlert;
